import { warn as m } from "./ghl-ui.es853.js";
import { toHexaString as o, rgba as u, toHslaString as c, toHsvaString as h, toRgbaString as i, hsla as v, hsva as l } from "./ghl-ui.es904.js";
import { rgb2hsl as g, rgb2hsv as b, hsl2rgb as a, hsl2hsv as x, hsv2rgb as f, hsv2hsl as d } from "./ghl-ui.es920.js";
function z(r, n) {
  switch (r[0]) {
    case "hex":
      return n ? "#000000FF" : "#000000";
    case "rgb":
      return n ? "rgba(0, 0, 0, 1)" : "rgb(0, 0, 0)";
    case "hsl":
      return n ? "hsla(0, 0%, 0%, 1)" : "hsl(0, 0%, 0%)";
    case "hsv":
      return n ? "hsva(0, 0%, 0%, 1)" : "hsv(0, 0%, 0%)";
  }
  return process.env.NODE_ENV !== "production" && m("color-picker", "props.modes is invalid."), "#000000";
}
function H(r) {
  return r === null ? null : /^ *#/.test(r) ? "hex" : r.includes("rgb") ? "rgb" : r.includes("hsl") ? "hsl" : r.includes("hsv") ? "hsv" : null;
}
function D(r) {
  return r = Math.round(r), r >= 360 ? 359 : r < 0 ? 0 : r;
}
function E(r) {
  return r = Math.round(r * 100) / 100, r > 1 ? 1 : r < 0 ? 0 : r;
}
const S = {
  rgb: {
    hex(r) {
      return o(u(r));
    },
    hsl(r) {
      const [n, t, s, e] = u(r);
      return c([...g(n, t, s), e]);
    },
    hsv(r) {
      const [n, t, s, e] = u(r);
      return h([...b(n, t, s), e]);
    }
  },
  hex: {
    rgb(r) {
      return i(u(r));
    },
    hsl(r) {
      const [n, t, s, e] = u(r);
      return c([...g(n, t, s), e]);
    },
    hsv(r) {
      const [n, t, s, e] = u(r);
      return h([...b(n, t, s), e]);
    }
  },
  hsl: {
    hex(r) {
      const [n, t, s, e] = v(r);
      return o([...a(n, t, s), e]);
    },
    rgb(r) {
      const [n, t, s, e] = v(r);
      return i([...a(n, t, s), e]);
    },
    hsv(r) {
      const [n, t, s, e] = v(r);
      return h([...x(n, t, s), e]);
    }
  },
  hsv: {
    hex(r) {
      const [n, t, s, e] = l(r);
      return o([...f(n, t, s), e]);
    },
    rgb(r) {
      const [n, t, s, e] = l(r);
      return i([...f(n, t, s), e]);
    },
    hsl(r) {
      const [n, t, s, e] = l(r);
      return c([...d(n, t, s), e]);
    }
  }
};
function N(r, n, t) {
  return t = t || H(r), t ? t === n ? r : S[t][n](r) : null;
}
export {
  N as convertColor,
  z as deriveDefaultValue,
  H as getModeFromValue,
  E as normalizeAlpha,
  D as normalizeHue
};
